import React, { useState } from 'react';
import Select from 'react-select';
import ErrorSvg from '../../assets/error.svg';
import Icon from '../../../../molecules/Icon';
import {
  Astericks,
  Container,
  ErrorIcon,
  ErrorMessage,
  Label,
  LabelContainer,
  SelectWrapper,
  Tooltip,
  TooltipContainer,
  Wrapper,
} from '../styles/FormSelect.styled';

const FormSelect = ({
  id,
  name,
  label,
  placeholder,
  required,
  errorMessage,
  value,
  options,
  handleChange,
  hidden,
  layout,
  styles,
  helperText,
  isMulti = false, // ✅ Add support for multi
}) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const formattedOptions = options.map(option => ({
    value: option.value,
    label: option.label,
  }));

  const selectedValue = isMulti
    ? formattedOptions.filter(opt => value?.includes(opt.value))
    : formattedOptions.find(opt => opt.value === value);

  return (
    <Container
      className={`custom-form-control control-${name}`}
      hidden={hidden}
      styles={styles}
    >
      <Wrapper className="custom-form-control-wrapper" layout={layout}>
        <LabelContainer>
          <Label htmlFor={name} className="custom-form-control-label">
            {label}
            {required && <Astericks>*</Astericks>}
          </Label>
          {helperText && (
            <TooltipContainer
              onMouseEnter={() => setTooltipVisible(true)}
              onMouseLeave={() => setTooltipVisible(false)}
            >
              <Icon id="info-circle" width="18px" height="18px" />
              <Tooltip className={tooltipVisible ? 'visible' : 'hidden'}>
                {helperText}
              </Tooltip>
            </TooltipContainer>
          )}
        </LabelContainer>
        <SelectWrapper>
          <Select
            inputId={id}
            name={name}
            placeholder={placeholder}
            options={formattedOptions}
            isMulti={isMulti}
            value={selectedValue}
            onChange={selected => {
              if (isMulti) {
                if (selected.length > 2) return;

                const newValue = selected.map(opt => opt.value);
                handleChange({ target: { name, value: newValue } });
              } else {
                const newValue = selected?.value || '';
                handleChange({ target: { name, value: newValue } });
              }
            }}
            className={errorMessage ? 'error' : ''}
            classNamePrefix="react-select"
          />
        </SelectWrapper>
        {errorMessage && (
          <ErrorIcon className="error-icon" src={ErrorSvg} alt="Error Icon" />
        )}
      </Wrapper>
      {errorMessage && (
        <ErrorMessage
          className="error-message"
          dangerouslySetInnerHTML={{ __html: errorMessage }}
        />
      )}
    </Container>
  );
};

export default FormSelect;
